import { render, staticRenderFns } from "./22.vue?vue&type=template&id=205d6088&scoped=true&"
import script from "./22.vue?vue&type=script&lang=js&"
export * from "./22.vue?vue&type=script&lang=js&"
import style0 from "./22.vue?vue&type=style&index=0&id=205d6088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205d6088",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('205d6088')) {
      api.createRecord('205d6088', component.options)
    } else {
      api.reload('205d6088', component.options)
    }
    module.hot.accept("./22.vue?vue&type=template&id=205d6088&scoped=true&", function () {
      api.rerender('205d6088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/22.vue"
export default component.exports